export const site = {
  name: '40 Yawgoo Consulting',
  email: 'hello@40yawgoo.com',
  linkedInUrl: 'https://www.linkedin.com/company/40-yawgoo-consulting'
};
export const textures = {
  // Hand-painted ink wash from the 40 Yawgoo Design System. One per page.
  wash: 'https://cdn.magicpatterns.com/patterns/generated-images/911eb381-e080-46e5-9630-30875ff737ce.jpg'
};
export const hero = {
  headline: 'We help founders solve problems that don’t have obvious answers.',
  paragraph: 'Our clients lead companies that shape how people responsibly invest and live. We turn undefined opportunities into clear decisions, then build the go-to-market and operating systems that bring in new revenue.'
};
export const contact = {
  statement: 'Our focus is how people responsibly invest and live. Our curiosity is broader.',
  prompt: 'Bring us a hard problem:'
};
export const footer = {
  builtBy: 'This site was thoughtfully built by Ash B  @ 40 Yawgoo Consulting.',
  copyright: '© 40 Yawgoo Consulting 2026'
};